
import { downloadPrompt } from '@/utils/file'

function dataURItoBlob(dataURI) {
  // REF: https://gist.github.com/fupslot/5015897
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  var byteString = atob(dataURI.split(',')[1])

  // separate out the mime component
  // var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length)
  var ia = new Uint8Array(ab)
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }

  // write the ArrayBuffer to a blob, and you're done
  var bb = new Blob([ab])
  return bb
}

export const chartMixin = {
  methods: {
    exportChart() {
      if (this.$refs.chart && this.$refs.chart.$data && this.$refs.chart.$data._chart) {
        const imageData = this.$refs.chart.$data._chart.toBase64Image()
        const blob = dataURItoBlob(imageData)
        var filename = 'chart.png'
        downloadPrompt(blob, filename)
      } else {
        this.$snotify.error('Error exporting chart')
      }
    }
  }
}
